import $ from 'jquery';
var numberOfGuestAllowed = $("#maxNumberOfGuestAllowed").val();
$('.cwm-guest-input .svg-minus').addClass('cwm-disabled-svg');
// Guest No. Counter
$(document).ready(function(){
    
       $(document).on('click','.svg-plus',function(){
        $('.cwm-guest-input .svg-minus').removeClass('cwm-disabled-svg')
        $('#cwm-guest-no').val(parseInt($('#cwm-guest-no').val()) + 1 );
        if ($('#cwm-guest-no').val() == parseInt($('#maxNumberOfGuestAllowed').val()) + 1) {
           
            $('#cwm-guest-no').val(numberOfGuestAllowed);
        }   
       else if ($('#cwm-guest-no').val() == parseInt($('#maxNumberOfGuestAllowed').val())) {
        $('.cwm-guest-input .svg-plus').addClass('cwm-disabled-svg');
        }
    });

    $(document).on('click','.svg-minus',function(){
        $('.cwm-guest-input .svg-plus').removeClass('cwm-disabled-svg')
        $('#cwm-guest-no').val(parseInt($('.cwm-count').val()) - 1 );
            if ($('#cwm-guest-no').val() == 0) {
                $('#cwm-guest-no').val(1);
            }
         else if ($('#cwm-guest-no').val() == '1') {
                $('.cwm-guest-input .svg-minus').addClass('cwm-disabled-svg');
               
            }
        });
       
 });
 $(".cwm-new-theme .cwm-reload").click(function(){
    window.location.reload();    
  });
  


// WEBPACK FOOTER //
// ./components/cwm-connection-event/cwm-guest-counter.js